import { connect } from "react-redux";
import FdesEditPage from "../pages/FdesEdit";
import {
  loadFdesParameters,
  saveFdesForm,
  saveFdesRealTimeForm,
  loadReference,
  saveFdesResult,
  generateReports,
  updateCalcul,
  upgradeCalcul,
  getFdesMetaData,
} from "../actions";
import { getFdesFormIsEdited } from "../selectors";
import {
  clearCalcul,
  getCalcul,
  removeReports,
  sendXmlToEDEC,
} from "../../calcul/actions";
import { getLocalEDECIntegration } from "../../../modules/user/actions";

export default connect(
  (state) => ({
    user: state.user.informations,
    isGeneratingReports: state.loader.isGeneratingReports,
    calculIsLoading: state.loader.calculIsLoading,
    familyProducts: state.familyProduct.familyProducts,
    formIsLoading: state.fdes.form.isLoading,
    isEdited: getFdesFormIsEdited(state),
    resultFormIsLoading: state.fdes.resultForm.isLoading,
    resultFormIsSaved: state.fdes.resultForm.isSaved,
    metadata: state.fdes.metadata,
    calculs: state.calculs.calculs,
    calcul: state.calculs.calcul,
    reports: state.calculs.calculReports,
    isSaved: state.fdes.form.isSaved,
    isFormUpdated: state.fdes.form.isFormUpdated,
    localConfigurator: state.configurator.localConfigurator,
    localEDECIntegration: state.configurator.localEDECIntegration,
    simulationMode: state.fdes.simulationMode,
    fdesParameters: state.fdes.fdesParameters,
  }),
  (dispatch) => ({
    loadFdesParameters: (fdesId, api, calcul, isEditMode) => {
      dispatch(loadFdesParameters(fdesId, api, calcul, isEditMode));
    },
    saveFdesForm: (fdesId) => {
      dispatch(saveFdesForm(fdesId));
    },
    saveFdesRealTimeForm: (api, fdesId) => {
      dispatch(saveFdesRealTimeForm(api, fdesId));
    },
    loadReference: (standard) => {
      dispatch(loadReference(standard));
    },
    saveFdesResult: () => {
      dispatch(saveFdesResult());
    },
    generateReports: (filesToGenerate, userFdesId) => {
      dispatch(generateReports(filesToGenerate, userFdesId));
    },
    updateCalcul: (calculId) => {
      dispatch(updateCalcul(calculId));
    },
    onUpgradeCalcul: (calculId) => {
      dispatch(upgradeCalcul(calculId));
    },
    getFdesMetadata: (fdesId) => {
      dispatch(getFdesMetaData(fdesId));
    },
    getCalcul: (calculId) => {
      dispatch(getCalcul(calculId));
    },
    sendXmlToEDEC: (values) => {
      dispatch(sendXmlToEDEC(values));
    },
    removeReports: () => {
      dispatch(removeReports());
    },
    getLocalEDECIntegration: () => {
      dispatch(getLocalEDECIntegration());
    },
    clearCalcul: () => {
      dispatch(clearCalcul());
    },
  }),
)(FdesEditPage);
